import { IMinerDataCopyProps } from "./MinerDataCopy.props";
import styles from "./MinerDataCopy.module.scss";
import Icon from "@components/global/new/Icon/Icon";
import cn from "classnames";

import copy from "@assets/redesign/icons/copy.svg";
import { Button, Tooltip } from "antd";
import { useMinerDataCopyControl } from "./MinerDataCopyControl";

export default function MinerDataCopy({ ...props }: IMinerDataCopyProps) {
  const {
    children,
    className,
    copyClassName,
    text,
    minerId,
    isDeviceID,
    hideDataCopy,
  } = props;
  const control = useMinerDataCopyControl(props);

  return (
    <div className={cn(styles.wrapper, className)}>
      {children}
      <Tooltip
        open={isDeviceID || hideDataCopy ? false : undefined}
        placement="right"
        color="#fff"
        afterOpenChange={control.onLoadMinerData}
        title={
          <div className={styles.data_copy}>
            <Button
              size="small"
              className={styles.btn}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                control.onCopyData("IP");
              }}
              loading={control.loader === "IP" || control.loader === "ALL"}
              disabled={(control.minerData?.ip?.length || 0) < 1}
            >
              IP
            </Button>
            <Button
              size="small"
              className={styles.btn}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                control.onCopyData("MAC");
              }}
              loading={control.loader === "MAC" || control.loader === "ALL"}
              disabled={(control.minerData?.mac?.length || 0) < 1}
            >
              MAC
            </Button>
            <Button
              size="small"
              className={styles.btn}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                control.onCopyData("PASS");
              }}
              loading={control.loader === "PASS" || control.loader === "ALL"}
              disabled={(control.minerData?.password?.length || 0) < 1}
            >
              PASS
            </Button>
          </div>
        }
      >
        {!isDeviceID && (
          <Icon
            src={copy}
            className={cn(copyClassName)}
            onClick={control.onClick}
            noHover
          />
        )}
      </Tooltip>
    </div>
  );
}
